import { render, staticRenderFns } from "./u-card-border-left.vue?vue&type=template&id=e949c678&scoped=true&"
import script from "./u-card-border-left.vue?vue&type=script&lang=js&"
export * from "./u-card-border-left.vue?vue&type=script&lang=js&"
import style0 from "./u-card-border-left.vue?vue&type=style&index=0&id=e949c678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e949c678",
  null
  
)

export default component.exports